//Change the position of the autocomplete search in the search bar

(function ($) {
    $(document).ajaxComplete(function () {
      if (document.body.classList.contains('.menu-open')) {
        var $autocomplete = $('.search-api-autocomplete-search');

        if ($autocomplete.length) {
          var $input = $('.main-header-wrapper #block-nla-herosearchblock input.ui-autocomplete-input');
          var $wrapper = $input.closest('.js-form-type-search-api-autocomplete');
          if ($wrapper.length) {
            $autocomplete.css({
              'position': 'absolute',
            });
            $autocomplete.appendTo($wrapper);
          }
        }
      }
    });
  })(jQuery);